<template>
  <form class="step" @submit.prevent="submit">
    <div class="step-row">
      <file-field fileType="image"
                  v-model="documents[documentTypes.tokenIcon]"
                  :accept="'image/*'"
                  :fieldType="'tokenCreation'"
                  :label="i18n.sale_token_logo_title()"
                  class="step__file-field"
                  :id="'tokenImg'"
                  :type="documentTypes.tokenIcon"
                  :disableField="disableForm"
      />
      <input-field id="token-name"
                   class="field_medium"
                   name="token name"
                   v-model="form.tokenName"
                   v-validate="{
                    required: true,
                    max: 30
                   }"
                   :label="i18n.sale_name_token_title()"
                   :placeholder="i18n.sale_my_token()"
                   :errorMessage="errorMessage('token name')"
                   :disabled="disableForm"
      />
      <div class="field-mask field_medium">
        <label for="token-code">{{ i18n.sale_token_code_title() }}</label>
        <the-mask  v-model="form.tokenCode"
                   id="token-code"
                   name="token code"
                   v-validate="'required'"
                   placeholder="ABC01"
                   :errorMessage="errorMessage('token code')"
                   :mask="['XXXXX']"
                   :disabled="disableForm"
        />
      </div>
      <div class="step-row__description text_small">
        <div>{{ i18n.sale_token_code_description() }}</div>
        <div>{{ i18n.sale_token_code_description_2() }}</div>
      </div>
      <div class="step-row__title text_small">
        <md-checkbox v-model="form.policies"
                     :value="ASSET_POLICIES.transferable"
                     name="policy-transferable"
                     id="policy-transferable"
                     class="md-primary"
                     :disabled="disableForm"
        >
          <div class="step__token-checkbox">{{ i18n.lbl_is_transferable() }}</div>
        </md-checkbox>
      </div>

      <div class="field-icon__wrap">
        <input-field id="token-max-issuance-amount"
                     name="max issuance amount"
                     class="field_medium field__number"
                     type="number"
                     v-model="form.maxIssuanceAmount"
                     v-validate="'required|amount'"
                     :label="i18n.sale_token_for_sale()"
                     :placeholder="i18n.lbl_token_max_issuance_amount()"
                     :errorMessage="errorMessage('max issuance amount')"
                     :disabled="disableForm"
        />
        <div class="field-icon">{{ form.tokenCode }}</div>
      </div>
    </div>
    <div v-if="disableForm" class="step__token-created">{{ i18n.sale_token_created() }}</div>
    <div class="btn-wrap column">
      <md-button type="submit" class="btn md-primary" :disabled="isPending">
        {{ i18n.sale_next_step() }}
      </md-button>
      <md-button @click="stepBack()" class="simple-link arrow_back">
        {{ i18n.lbl_go_back_2() }}
      </md-button>
    </div>
  </form>
</template>

<script>
  import StepMixin from './step.mixin'
  import config from '@conf'
  import { ErrorHandler } from '@js/errors/error_handler'
  import { commonEvents } from '@js/events/common_events'
  import { ASSET_POLICIES, documentTypes, CREATE_TOKEN_REQUEST_STATES } from '@const'
  import { i18n } from '@js/i18n'
  import { fileService } from '@api/file.service'
  import { TheMask } from 'vue-the-mask'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { DocumentContainer } from '@js/helpers/DocumentContainer'
  import { CurrencyHelper } from '@js/helpers/currency.helper'
  import _pick from 'lodash/pick'

  export default {
    name: 'StepTokenCreation',
    mixins: [StepMixin],
    components: { TheMask },
    data: _ => ({
      form: {
        tokenName: '',
        tokenCode: '',
        maxIssuanceAmount: '',
        policies: 1
      },
      documents: {
        tokenIcon: null
      },
      disableForm: false,
      i18n,
      config,
      documentTypes,
      ASSET_POLICIES,
      CurrencyHelper
    }),

    async created () {
      this.form = _pick(this.token, Object.keys(this.form))
      if (this.token.logo) {
        this.documents[documentTypes.tokenIcon] = this.token.logo.key ? new DocumentContainer(this.token.logo) : null
      }
      this.disableForm = this.token.state === CREATE_TOKEN_REQUEST_STATES.approved.codeVerbose || this.token.stateI === CREATE_TOKEN_REQUEST_STATES.approved.code
    },
    methods: {
      stepBack () {
        this.$emit(commonEvents.saleStepBack)
      },
      assetIcon (asset) {
        return CurrencyHelper.getCurrencyIcon(asset)
      },
      async submit () {
        const logoContainer = this.documents[documentTypes.tokenIcon]

        if (logoContainer && !logoContainer.isUploaded) {
          const logoKey = await fileService.uploadFile(logoContainer.getDetailsForUpload())
          logoContainer.setKey(logoKey)
        }

        this.documents.tokenIcon = logoContainer ? logoContainer.getDetailsForSave() : {}

        if (!await this.isValid()) return
        if (!logoContainer) {
          EventDispatcher.dispatchShowErrorEvent(i18n.mod_empty_token_logo())
          return
        }
        this.disable()
        try {
          this.$emit(commonEvents.tokenCreateEvent, {
            form: this.form,
            documents: this.documents
          })
        } catch (error) {
          ErrorHandler.processUnexpected(error)
        }
        this.enable()
      }
    }
  }
</script>

<style scoped lang="scss">
  @import './step.scss';
  @import "~scss/mixins";
  @import "~scss/variables";

  .step__token-created {
    padding: 0 30px 30px;
    font-size: 18px;
    font-weight: 600;
    color: $col-text;
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/saleCreation/steps/Step.TokenCreation.vue